import { render, staticRenderFns } from "./Roledata.vue?vue&type=template&id=f21d7762&scoped=true"
import script from "./Roledata.vue?vue&type=script&lang=js"
export * from "./Roledata.vue?vue&type=script&lang=js"
import style0 from "./Roledata.vue?vue&type=style&index=0&id=f21d7762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21d7762",
  null
  
)

export default component.exports